export const selectAllDatabases = (payload) =>
	payload.map((database) => ({
		id: parseInt(database.id, 10),
		key: parseInt(database.id, 10),
		title: database.name,
		row_count: parseInt(database.row_count, 10),
		structure: database.structure,
	}))

export const selectAllTags = (payload) =>
	payload.map((tags) => ({
		id: tags.id,
		title: tags.title,
	}))
